import { YAK_TRAILS_CLIENT_TUNING } from "../tuning";

export const TERRITORY_SURFACE_Y = YAK_TRAILS_CLIENT_TUNING.territory.surfaceY;
export const TRAIL_CONTACT_Y = YAK_TRAILS_CLIENT_TUNING.territory.trailContactY;
export const TRAIL_SURFACE_Y = YAK_TRAILS_CLIENT_TUNING.territory.trailSurfaceY;
